import * as AppConstants from 'app/AppConstants';
import mapValues from 'lodash/mapValues';

export const initialState = () => ({
  properties: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.BUZZ__FLAT_MESSAGES_LOADED:
    case AppConstants.BUZZ__HUDDLE_MESSAGE_CREATED_BY_SERVER:
    case AppConstants.BUZZ__LOAD_HUDDLE_MESSAGES_FINISHED:
    case AppConstants.BUZZ__MESSAGE_CREATED_BY_SERVER:
    case AppConstants.BUZZ__USER_CREATE_MESSAGE_FINISHED:
    case AppConstants.SEARCH__EXECUTED_SEARCH_DOMOBUZZ:
    case AppConstants.SEARCH__QUERY_FINISHED:
    case AppConstants.BUZZ__LOADED_PINNED_CHANNELS:
    case AppConstants.BUZZ__LOADED_RECENT_ACTIVITY_TOPIC_CHANNELS:
      return {
        ...state,
        properties: {
          ...state.properties,
          ...mapValues(action.payload.properties, val => ({
            displayName: val.DISPLAY,
            imageUri: val.ICON_URL,
            avatarKey: val.AVATAR_KEY,
          })),
        },
      };

    case AppConstants.PEOPLE__PROFILE_EDIT_STARTED:
    case AppConstants.PEOPLE__PROFILE_EDIT_FINISHED: {
      const {userId, profile} = action.payload;
      const key = `USER:${userId}`;
      return {
        ...state,
        properties: {
          ...state.properties,
          [key]: {
            ...state.properties[key],
            avatarKey: profile.profileImage,
          },
        },
      };
    }

    default:
      return state;
  }
};
